<template>
    <div>
        <div class="d-md-none pb-3 pb-md-0">
            <router-link class="btn btn-primary btn-select-accessories" :to="{name:'catalog'}">
                {{t('button.accessories')}}
            </router-link>
        </div>

        <div class="d-none d-md-block">
            <loading v-if="loading"></loading>
            <div v-else>
                <div v-if="catalogMessage" v-html="catalogMessage"></div>

                <div v-if="error">{{t('error')}}</div>
                <div v-else>
                    <products-grouping v-for="grouping in products" :grouping="grouping"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import mixin_constraints from "@/mixins/constraints";
    import {retryRequest} from "@/helpers/request";

    import Loading from "@/components/Loading";
    import ProductsGrouping from "@/components/products/ProductsGrouping";

    export default {
        name: "ViewsHomeTypeProducts",
        mixins: [mixin_constraints],
        components: {
            ProductsGrouping,
            Loading
        },
        props: {
            grouping: {
                type: String,
                required: true
            },
            groupings: {
                type: Array,
                required: true
            },
            config: {
                type: Object,
                required: true
            },
            catalogMessage: String
        },
        data() {

            return {
                t_path: "views.home",
                loading: false,
                error: false,
                products: [],
            }
        },
        methods: {
            fetch() {

                this.loading = true;

                const promises = this.groupings.map(item => retryRequest(() => this.$platform.get(`/api/v2/grouping/${this.grouping}/${item.id}`)));

                return Promise
                    .all(promises)
                    .then(responses => responses.forEach(response => {

                        const result = response.data.results;
                        const items = this.constraints_filterAvailableProducts(result.products);
                        const max = this.config[result._id]
                            ? this.config[result._id].max_items
                            : this.config.default.max_items;
                        const total = "undefined" !== typeof result.total
                            ? result.total
                            : items.length;

                        this.$activity.log("catalog_grouping_products", {
                            grouping_id: result._id,
                            products: items.slice(0, max),
                            constraints: this.$store.getters["user/constraints/type"]
                        });

                        if (0 < items.length) {

                            this.products.push({
                                ...result,
                                id: result._id,
                                type: this.grouping,
                                items: items.slice(0, max),
                                showMore: total > items.slice(0, max).length
                            });
                        }
                    }))
                    .catch(() => this.error = true)
                    .finally(() => this.loading = false);
            }
        },
        mounted() {

            this.fetch();
        }
    }
</script>